import { api } from 'api/api'

export const removeCouponService = async (couponId: string) => {
  return await api.delete(`/api/backoffice/coupons/${couponId}`)
}
